/**
 * Admission contacts, exactly as the institute publishes them:
 * https://www.bietdvg.edu/admission/contact
 *
 * Names, designations and numbers are reproduced as published — this is a page
 * the institute puts up precisely so applicants can call these people, so
 * nothing here is inferred and nothing invented.
 *
 * The same source page also lists the two hostel wardens. They are not carried
 * here: they answer accommodation questions rather than admission ones, and
 * hostels.ts already holds the full warden and deputy-warden roster for both
 * hostels. One source per fact.
 */

export interface AdmissionContact {
  name: string;
  /** Staff-directory slug to borrow a portrait from — verified exact matches. */
  staffSlug?: string;
  role: string;
  email: string;
  phone: string;
}

/** Dean of Admissions first — the office whose job this is. */
export const ADMISSION_CONTACTS: AdmissionContact[] = [
  {
    name: "Dr. Leela G.H.",
    staffSlug: "leela-g-h",
    role: "Dean, Admissions",
    email: "admissions@bietdvg.edu",
    phone: "+91 98444 74712",
  },
  {
    name: "Dr. H.B. Aravind",
    staffSlug: "h-b-aravind",
    role: "Principal",
    email: "principal@bietdvg.edu",
    phone: "+91 88618 64398",
  },
  {
    name: "Prof. Y. Vrushabhendrappa",
    staffSlug: "y-vrushabhendrappa",
    role: "Director",
    email: "director@bietdvg.edu",
    phone: "+91 94483 93144",
  },
];
